/** @jsxImportSource @emotion/react */

import { Dialog, DialogTitle } from '@mui/material';
import './style.css'

export function PopupTitle(props) {
    /*
        List of props
        backgroundColor - for custom background color
        dontShowCloseIcon - boolean(true) value for not showing/displaying close icon
    */

    let css = {
        dialogTitle : {
            backgroundColor : "#FFFFFF"
        },
        closeIcon : {
            float : "right",
            cursor : "pointer"
        }
    }

    return (
        <DialogTitle css={props.customCSS ? {...props.customCSS,  backgroundColor: props.backgroundColor || css.dialogTitle} : { backgroundColor: props.backgroundColor || css.dialogTitle}}>
            {props.children}
            {!props.dontShowCloseIcon && <img src="images/icon_close_black.svg" alt="icon_close_black" css={css.closeIcon} onClick={props?.onClose} />}
        </DialogTitle>
    );
}

export default function Popup(props) {
    return (
        <Dialog {...props}>
            {props.children}
        </Dialog>
    );
}